import React, { Component } from 'react';
import { ActivityType } from "../../global/Enum";

class ActivityHeader extends Component {
    render() {
        const { type, code, title, subTitle } = this.props;
        let headerColor;

        switch (type) {
            case ActivityType.INDIVIDUAL_VISIT:
                headerColor = "yellow-activity"
                break;
            case ActivityType.SAMPLE_DISTRIBUTION:
                headerColor = "brown-activity"
                break;
            case ActivityType.GROUP_MEETING:
                headerColor = "blue-activity"
                break;
            case ActivityType.SAMPLE_TO_SALE:
                headerColor = "green-activity"
                break;
            default:
                break;
        }

        let activityHeaderStyle = "activity-info-box " + headerColor + " text-white mb-3 max-w-460";
        return (
            <div className={activityHeaderStyle}>
                <span>{code}</span>
                <h5>{title}</h5>
                <span>{subTitle}</span>
            </div>
        )
    }
}

export default ActivityHeader;
